import { AntDesign } from "@expo/vector-icons";
import { Customer } from "@towersystems/roam-common/lib/generated-types";
import { Spacings, TouchableOpacity, View } from "react-native-ui-lib";
import colors from "react-native-ui-lib/src/style/colors";
import { Badge, Stack, Text } from "@towersystems/roam-common-native";

export interface CustomerResourceListItemProps {
  customer: Customer;
  action: () => void;
  actionRightComponent?: React.ReactNode;
  actionRightLabel?: string;
}

export const CustomerResourceListItem = ({
  customer,
  action,
  actionRightComponent,
  actionRightLabel,
}: CustomerResourceListItemProps) => {
  const componentRightMarkup = actionRightComponent ? (
    actionRightComponent
  ) : (
    <>
      <View>
        {actionRightLabel && <Text variant="heading1">{actionRightLabel}</Text>}
      </View>
      <AntDesign
        style={[{ marginLeft: Spacings.s4 }]}
        name="right"
        size={24}
        color={colors.text}
      />
    </>
  );

  const badgeMarkup = customer.isRetailerCusAccount ? (
    <Badge retailerCustomerAccountStatus="RETAILER_CUSTOMER_ACCOUNT" />
  ) : null;

  return (
    <TouchableOpacity
      onPress={action}
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
      }}
    >
      <View row centerV style={{ flexBasis: "100%", flexShrink: 1 }}>
        <View style={{ flexShrink: 1 }}>
          <Stack spacing={Spacings.s2} vertical>
            <View>
              <Text
                variant="heading"
                fontWeight="medium"
                numberOfLines={1}
                ellipsizeMode="head"
              >
                {customer.firstName} {customer.lastName}
              </Text>
            </View>
            {customer.emailAddress ? (
              <Text color="subdued" variant="heading5">
                {customer.emailAddress}
              </Text>
            ) : undefined}
            {badgeMarkup}
          </Stack>
        </View>
      </View>
      <View style={{ paddingLeft: Spacings.s6 }} row centerV>
        {componentRightMarkup}
      </View>
    </TouchableOpacity>
  );
};
